import { render, staticRenderFns } from "./TransporterRFQDetails.vue?vue&type=template&id=7e8a59a2&scoped=true"
import script from "./TransporterRFQDetails.vue?vue&type=script&lang=js"
export * from "./TransporterRFQDetails.vue?vue&type=script&lang=js"
import style0 from "./TransporterRFQDetails.vue?vue&type=style&index=0&id=7e8a59a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a59a2",
  null
  
)

export default component.exports